import {Fragment} from 'react';

import ShopPopUp from 'topmeteo/general/components/ShopPopUp';
import RegionSelect from 'topmeteo/general/components/RegionSelect';

const Base = props => (
    <Fragment>
        <ShopPopUp />
        <RegionSelect {...props} />
    </Fragment>
);

export default Base;
